// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalLazy_modal__1N0v-","bg":"ModalLazy_bg__1FOS6","fadeIn":"ModalLazy_fadeIn__2gMNO","overlay":"ModalLazy_overlay__2TJCW"};